var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},_vm._l((_vm.categories),function(category){return _c('admin-message-list-card',{key:category.title,attrs:{"title":category.title,"image":category.image,"image_selected":category.image_selected}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }